export const colors = {
  background: "#f2f2f3",
  white: "#FFFFFF",

  primary: {
    $100: "#E8FAF8",
    $200: "#15D1BB",
    $300: "#068677",
  },
  secondary: {
    $100: "#E5E6FF",
    $200: "#4B44FD",
    $300: "#28249C",
  },
  grey: {
    $100: "#F8F8F8",
    $200: "#E9EAF0",
    $300: "#E1E1E1",
    $400: "#919299",
    $500: "#616172",
    $600: "#1D1E21",
  },

  black: {
    $100: "#F8F8F8",
    $200: "#E1E1E1",
    $300: "#CCCCCC",
    $400: "#B0B0B1",
    $500: "#919299",
    $600: "#3D3E42",
    $700: "#292A2E",
    $800: "#242529",
    $900: "#1D1E21",
    $1000: "#000000",
  },

  success: {
    $100: "#CDFAD8",
    $200: "#54D575",
    $300: "#27A847",
  },
  info: {
    $100: "#D1EAFF",
    $200: "#0890FF",
    $300: "#0765B2",
  },
  warning: {
    $100: "#FFF9DF",
    $200: "#FFAB00",
    $300: "#EB7900",
  },
  danger: {
    $100: "#FFE7EF",
    $200: "#FF3366",
    $300: "#9E243F",
  },
  gradient: {
    purple: "#A97EFF",
    green: "#B0F0D9",
    yellow: "#FCDE74",
  },
  majorelle: "#624AFF",
  indigo: "#A97EFF",
} as const
